<template>
  <p>
    {{ parseTranslation(QUESTION_ANSWERED, question_result.count, average) }}
  </p>
</template>

<script>
import * as translationAverage from './Average.translations'

const { default: translations, ...translationKeys } = translationAverage

export default {
  props: {
    question_result: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
    }
  },

  computed: {
    average() {
      const asNumber = Number(this.question_result.value || 0)

      const TWO_DECIMAL_CASES = 2

      return asNumber.toFixed(TWO_DECIMAL_CASES)
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  width: 80%;
  margin: 30px auto 0;
  font-size: rem(16);
  text-align: center;

  color: $white;

  .light & {
    color: $gray-9;
  }
}
</style>
